import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar"
import Footer from "../components/Footer/Footer"
const PublicLayout = () => {
  return (
    <div className="PublicLayout">
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default PublicLayout;
